module.exports = __webpack_public_path__ + "static/media/01.2e402f4b.png";